import { Container } from '@mui/material';
import { useState } from 'react';
import CustomBR from '../foundation/CustomBR';
import Page from '../layout/base.page';
import UserNotification, { UserNotificationProps } from '../components/UserNotification';
import UserNotificationSettings from '../components/UserNotificationSettings';
import { NotificationDto } from '../../../common/notifications.types';

export type UserSettingsNotificationsPageProps = {
    url: string;
    userId?: number;
    userNotificationSettings?: Record<string, NotificationDto>;
}

const UserSettingsNotificationsPage = (props: UserSettingsNotificationsPageProps) => {
    const [notification, setNotification] = useState<UserNotificationProps>(null);
    return <Page
        showBreadCrumbs={false}
        url={props.url}
        pageHeaderTitle="Mploy - הגדרות משתמש">
        <Container>
            <CustomBR />
            {notification && <>
                <UserNotification blink {...notification} />
                <CustomBR />
            </>}
            <CustomBR />
            <CustomBR />
            <UserNotificationSettings userId={props.userId} activeNotificationSettings={props.userNotificationSettings} setNotification={setNotification} />
            <CustomBR />
        </Container>
        <CustomBR />
    </Page>;
};

export default UserSettingsNotificationsPage;
